module.exports = __webpack_public_path__ + "img/egg_shadow.2aa94276.png";